import { Phone, ArrowRight } from "lucide-react";
import { BRAND } from "@/data/site";
import { track } from "@/lib/track";

export function CallButton({ id, className = "btn-brand", label }: { id: string; className?: string; label?: React.ReactNode }) {
  return (
    <a
      href={BRAND.phoneHref}
      data-testid={id}
      className={className}
      onClick={() => track("call_click", { location: id })}
    >
      <Phone className="h-5 w-5" strokeWidth={2.5} />
      {label || `Call ${BRAND.phone}`}
    </a>
  );
}

export function scrollToQuote() {
  document.getElementById("quote")?.scrollIntoView({ behavior: "smooth", block: "start" });
  track("quote_cta_click");
}

export function QuoteButton({ id, className = "btn-ghost", label = "Request a Quote" }: { id: string; className?: string; label?: string }) {
  return (
    <button type="button" data-testid={id} className={className} onClick={scrollToQuote}>
      {label}
      <ArrowRight className="h-5 w-5" />
    </button>
  );
}
